<ul class="w-full flex sm:gap-x-4 sm:justify-start justify-between">
  <li *ngFor="let item of options"
    [ngClass]="{'!bg-[#808080] text-white': selectedValue === item}"
    (click)="onValueChange(item)"
    class="py-0.5 px-8 sm:px-3 bg-gray-100 rounded text-sm font-medium cursor-pointer"
  >{{ item }}</li>
</ul>